
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Lead, LeadType } from '@/types';

@Component
export default class LeadConvertDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Object) readonly conversion!: {
    version?: number;
    type?: LeadType;
    extra?: string;
  };

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadConvertDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get text(): string | false {
    if (this.conversion.extra === 'elettrica-figlia') {
      return 'Premendo il pulsante <strong>Converti</strong> la lead verrà convertita in una <em>Lead figlia elettrica</em> e verranno aggiunti i task MIR.';
    }

    if (this.conversion.extra === 'termica-figlia') {
      return 'Premendo il pulsante <strong>Converti</strong> la lead verrà convertita in una <em>Lead figlia termica</em> e verranno aggiunti i task MIR.';
    }

    if (this.conversion.extra === 'cm') {
      return 'Premendo il pulsante <strong>Converti</strong> verrà aggiunto il task Cm relativo alla trasformazione della lead in commessa.';
    }

    if (this.conversion.version === 3
      && this.conversion.type === 'standard') {
      return "Premendo il pulsante <strong>Converti</strong> la lead verr&agrave; convertita in una lead v3 di tipo 'standard'.";
    }

    if (this.conversion.version === 2
      && this.conversion.type === 'classica') {
      return "Premendo il pulsante <strong>Converti</strong> la lead verr&agrave; convertita in una lead v2 di tipo 'classica'.";
    }

    return false;
  }

  async onCancel() {
    console.log('LeadConvertDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onConvert() {
    console.log('LeadConvertDialog: onConvert()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('convertLead', this.conversion);

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
